import { render, staticRenderFns } from "./NumberRowEditor.vue?vue&type=template&id=2b5d626c&"
import script from "./NumberRowEditor.vue?vue&type=script&lang=ts&"
export * from "./NumberRowEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports